<template>
  <v-tooltip v-if="!noTooltip" bottom>
    <template v-slot:activator="{ on, attrs }">
      <v-btn
        :disabled="disabled"
        icon
        @click="$emit('click')"
        v-bind="attrs"
        v-on="on"
        :class="['actions-btn', { highlight }]"
      >
        <v-icon size="24">{{ icon }}</v-icon>
      </v-btn>
    </template>
    <span>{{ tooltip }}</span>
  </v-tooltip>

  <v-btn v-else :disabled="disabled" icon @click="$emit('click')" :class="['actions-btn', { highlight }]">
    <v-icon size="20">{{ icon }}</v-icon>
  </v-btn>
</template>

<script lang="ts">
import Vue from "vue";

export default Vue.extend({
  name: "ButtonAction",
  props: {
    tooltip: String,
    icon: String,
    disabled: Boolean,
    noTooltip: {
      type: Boolean,
      default: false,
    },
    highlight: {
      type: Boolean,
      default: false,
    },
  },
});
</script>

<style lang="scss" scoped>
@import "@/scss/custom_variables.scss";

.v-btn--round {
  border-radius: $space-smallest !important;
}

.highlight .v-icon:hover,
.highlight .v-icon:active {
  color: var(--v-accent-global-base) !important;
}
</style>
